export class ObjectParsing {
	public removeDuplicateByUniqueKey(arr: any, key: any): any {
		// store the comparison  values in array
		const unique = arr.map(e => e[key])

		// store the indexes of the unique objects
			.map((e, i, final) => final.indexOf(e) === i && i)

		// eliminate the false indexes & return unique objects
			.filter((e) => arr[e]).map(e => arr[e]);

		return unique;
	}
}

export const ObjectParsingInstance: ObjectParsing = new ObjectParsing();



// WEBPACK FOOTER //
// ./src/components/Controls/ObjectParsing.ts